// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { withRouter } from "react-router";
import classnames from "classnames";
import { Labeled, Page, Button } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./SocketsTesting.m.scss";

const SOCKET_STATE = {
  0: "CONNECTING",
  1: "OPEN",
  2: "CLOSING",
  3: "CLOSED",
};

// connecting component to the redux store
@withRouter
@themr("SocketsTesting", styles)
export default class SocketsTesting extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.localSocket = new WebSocket("ws://192.168.77.22:8080/ws/oktell/");
    this.preprodSocket = new WebSocket(
      "ws://processing-api.dev.cde.yc.life-pay.tech/ws/oktell12341/"
    );
    this.prodSocket = new WebSocket("wss://processing-api.life-pay.ru/ws/oktell12341/");

    this.state = {
      localState: this.localSocket.readyState,
      localMessages: [],
      preprodState: this.preprodSocket.readyState,
      preprodMessages: [],
      prodState: this.prodSocket.readyState,
      prodMessages: [],
    };
  }

  componentDidMount() {
    const sockets = [
      [this.localSocket, "local"],
      [this.preprodSocket, "preprod"],
      [this.prodSocket, "prod"],
    ];
    sockets.forEach(([socket, key]) => {
      this.bindSocketEventHandlers(socket, key);
    });
  }

  componentWillUnmount() {
    this.localSocket.close();
    this.preprodSocket.close();
    this.prodSocket.close();
  }

  bindSocketEventHandlers = (socket, key) => {
    socket.onopen = () => {
      console.log(key, "onopen", event);
      this.setState({
        [key + "State"]: socket.readyState,
      });
    };
    socket.onerror = (event) => {
      console.log(key, "onerror", event);
      this.setState({
        [key + "State"]: socket.readyState,
      });
    };
    socket.onclose = (event) => {
      console.log(key, "onclose", event);
      let reason;
      // See http://tools.ietf.org/html/rfc6455#section-7.4.1
      if (event.code === 1000)
        reason =
          "Normal closure, meaning that the purpose for which the connection was established has been fulfilled.";
      else if (event.code === 1001)
        reason =
          'An endpoint is "going away", such as a server going down or a browser having navigated away from a page.';
      else if (event.code === 1002)
        reason =
          "An endpoint is terminating the connection due to a protocol error";
      else if (event.code === 1003)
        reason =
          "An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message).";
      else if (event.code === 1004)
        reason =
          "Reserved. The specific meaning might be defined in the future.";
      else if (event.code === 1005)
        reason = "No status code was actually present.";
      else if (event.code === 1006)
        reason =
          "The connection was closed abnormally, e.g., without sending or receiving a Close control frame";
      else if (event.code === 1007)
        reason =
          "An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).";
      else if (event.code === 1008)
        reason =
          'An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.';
      else if (event.code === 1009)
        reason =
          "An endpoint is terminating the connection because it has received a message that is too big for it to process.";
      else if (event.code === 1010)
        // Note that this status code is not used by the server, because it can fail the WebSocket handshake instead.
        reason =
          "An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake. <br /> Specifically, the extensions that are needed are: " +
          event.reason;
      else if (event.code === 1011)
        reason =
          "A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.";
      else if (event.code === 1015)
        reason =
          "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).";
      else reason = "Unknown reason";
      this.setState({
        [key + "State"]: socket.readyState,
        [key + "Error"]: reason,
      });
    };
    socket.onmessage = (e) => {
      const data =
        typeof e.data === "object" ? JSON.parse(e.data) : e.data.toString();
      const origin = e.origin;
      const timeStamp = e.timeStamp;
      this.setState((prevState) => {
        const messages = prevState[key + "Messages"].slice();
        messages.push({
          data,
          origin,
          timeStamp,
        });
        return {
          [key + "Messages"]: messages,
        };
      });
    };
  };

  render() {
    const { theme } = this.props;
    const {
      localState,
      preprodState,
      prodState,
      localMessages,
      preprodMessages,
      prodMessages,
      localError,
      preprodError,
      prodError,
    } = this.state;
    console.log(this.state);
    return (
      <Page header={"Тестирование сокетов"}>
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.section)}>
            <Labeled label={"Статус сокета local"}>
              {SOCKET_STATE[localState]}
            </Labeled>
            <Labeled label={"Статус сокета preprod"}>
              {SOCKET_STATE[preprodState]}
            </Labeled>
            <Labeled label={"Статус сокета prod"}>
              {SOCKET_STATE[prodState]}
            </Labeled>
          </div>
          <div className={classnames(theme.section)}>
            <Labeled label={"Статус закрытия сокета local"}>
              {localError}
            </Labeled>
            <Labeled label={"Статус закрытия сокета preprod"}>
              {preprodError}
            </Labeled>
            <Labeled label={"Статус закрытия сокета prod"}>{prodError}</Labeled>
          </div>

          <div className={classnames(theme.section)}>
            <Labeled label={"Сообщения сокета local"}>
              {localMessages.map((message, index) => (
                <div key={message.timeStamp + index}>{`${message.timeStamp} ${
                  message.origin
                } ${message.data}`}</div>
              ))}
            </Labeled>
            <Labeled label={"Сообщения сокета preprod"}>
              {preprodMessages.map((message, index) => (
                <div key={message.timeStamp + index}>{`${message.timeStamp} ${
                  message.origin
                } ${message.data}`}</div>
              ))}
            </Labeled>
            <Labeled label={"Сообщения сокета prod"}>
              {prodMessages.map((message, index) => (
                <div key={message.timeStamp + index}>{`${message.timeStamp} ${
                  message.origin
                } ${message.data}`}</div>
              ))}
            </Labeled>
          </div>
          <div className={classnames(theme.section, theme.buttons)}>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.localSocket.send("foobar");
              }}
            >
              {"Отправить local"}
            </Button>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                console.log("sending");
                this.preprodSocket.send(
                  JSON.stringify({ example: "foobar_preprod" })
                );
              }}
            >
              {"Отправить preprod"}
            </Button>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.prodSocket.send("foobar");
              }}
            >
              {"Отправить prod"}
            </Button>
          </div>
          <div className={classnames(theme.section, theme.buttons)}>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.localSocket.close();
              }}
            >
              {"Закрыть local"}
            </Button>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.preprodSocket.close();
              }}
            >
              {"Закрыть preprod"}
            </Button>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.prodSocket.close();
              }}
            >
              {"Закрыть prod"}
            </Button>
          </div>
          <div className={classnames(theme.section, theme.buttons)}>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.localSocket = new WebSocket(
                  "ws://192.168.77.22:8080/ws/oktell/"
                );
                this.setState({
                  localError: null,
                  localState: this.localSocket.readyState,
                });
                this.bindSocketEventHandlers(this.localSocket, "local");
              }}
            >
              {"Открыть local"}
            </Button>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.preprodSocket = new WebSocket(
                  "ws://processing-api.dev.cde.yc.life-pay.tech/ws/oktell12341/"
                );
                this.setState({
                  preprodError: null,
                  preprodState: this.preprodSocket.readyState,
                });
                this.bindSocketEventHandlers(this.preprodSocket, "preprod");
              }}
            >
              {"Открыть preprod"}
            </Button>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                this.prodSocket = new WebSocket(
                  "wss://processing-api.life-pay.ru/ws/oktell12341/"
                );
                this.setState({
                  prodError: null,
                  prodState: this.prodSocket.readyState,
                });
                this.bindSocketEventHandlers(this.prodSocket, "prod");
              }}
            >
              {"Открыть prod"}
            </Button>
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Public/pages/SocketsTesting/SocketsTesting.js